export default "/institutions/porto.svg";